import { ServiceRequestContext } from '@/context/serviceRequestContext';
import { Button } from '@/globalComponents/button';
import { ChangeEvent, useContext, useEffect } from 'react';
import RadioGroup from '@/globalComponents/RadioGroup';
import TextArea from '@/globalComponents/textArea';
import { repairForm } from '@/labels/serviceRequest';
import styles from './style.module.scss';
import { ProductContext } from '@/context/productContext';
import { WebEngageContext } from '@/context/webengageContext';
import { AppScreens, WebEngageEventData, WebEngageEventNames } from '@/types/wegengage';
import WebEngageUtils from '@/utils/webengageUtils';

const RepairForm = () => {
  const { dispatch: serviceAction, state: serviceState } = useContext(ServiceRequestContext);
  const { state: productState } = useContext(ProductContext);
  const { selectedProduct } = productState;
  const { state: webengageState } = useContext(WebEngageContext);
  const { defectType, addnRemarks, webengageData } = serviceState;
  const _webengageObj: WebEngageEventData = {
    ...webengageState.webengageDefault,
    navigated_from: AppScreens.SERVICE_DEFECT_TYPE_SCREEN,
    customer_type: WebEngageUtils.stringUtil(selectedProduct?.expiryStatus?.status),
    mandatory_service_open: webengageData?.mandatory_service_open,
    service_request_open: webengageData?.service_request_open,
    scheduling_automation_flow: webengageData?.scheduling_automation_flow,
    product_selected: WebEngageUtils.stringUtil(webengageData?.product_selected),
    product_id: WebEngageUtils.stringUtil(webengageData?.product_id),
    service_type: WebEngageUtils.stringUtil(webengageData?.service_type),
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const _we = window.webengage;
    if (_we) {
      _we.track(WebEngageEventNames.SERVICE_DEFECT_TYPE_SCREEN_OPENED, _webengageObj);
    }
  }, []);

  const onFieldChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    serviceAction.updateRepairType({
      defectType,
      addnRemarks,
      [event.target.name]: event.target.value,
    });
    if (event.target.name === 'defectType') {
      const _we = window.webengage;
      if (_we) {
        serviceAction.initWebengageContext({
          defect_selected: WebEngageUtils.stringUtil(event?.target?.value),
        });
        _we.track(WebEngageEventNames.SERVICE_DEFECT_TYPE_SELECTED, {
          ..._webengageObj,
          defect_selected: WebEngageUtils.stringUtil(event?.target?.value),
        });
      }
    }
  };

  return (
    <form name="defect-form" data-testid="defect-form" className="flex flex-col">
      <section className="mt-8 flex flex-col md:w-[80%] md:mx-auto">
        <h2 className="text-lg md:text-2xl font-bold leading-7 my-1" data-testid="form-title">
          {repairForm.title}
        </h2>
        <RadioGroup
          options={repairForm.defectOptions}
          name="defectType"
          caption={repairForm.defectCaption}
          value={defectType}
          onChange={onFieldChange}
        />
        <div className="mt-8 md:mt-11">
          <label
            htmlFor="addnRemarks"
            className={`block leading-6 mb-4 ${styles.remarksLabel}`}
            data-testid="remarks-label"
          >
            {repairForm.remarksLabel}
          </label>
          <TextArea
            id="addnRemarks"
            rows={4}
            className="md:w-9/12]"
            onChange={onFieldChange}
            value={addnRemarks}
            maxLength={150}
          />
        </div>
      </section>
      <Button
        dataTestId="repairBtnNext"
        variant="primary"
        classNames="w-full mt-10 md:w-1/5 md:mt-20 md:self-end grid place-content-center uppercase"
        disabled={defectType === ''}
        onClick={() => {
          const _we = window.webengage;
          if (_we) {
            const _isRemarksFilled = WebEngageUtils.returnBoolString(addnRemarks?.length > 0);
            serviceAction.initWebengageContext({
              additional_remark_filled: _isRemarksFilled,
              additional_remark: WebEngageUtils.stringUtil(addnRemarks),
            });
            _we.track(WebEngageEventNames.SERVICE_DEFECT_SCREEN_NEXT_CLICKED, {
              ..._webengageObj,
              additional_remark_filled: _isRemarksFilled,
              additional_remark: WebEngageUtils.stringUtil(addnRemarks),
              defect_selected: WebEngageUtils.stringUtil(defectType),
            });
          }
          serviceAction.changeComponent('bookASlot');
        }}
      >
        Next
      </Button>
    </form>
  );
};

export default RepairForm;
